import { render, staticRenderFns } from "./Budget3.vue?vue&type=template&id=3446cf72&scoped=true"
import script from "./Budget3.vue?vue&type=script&lang=js"
export * from "./Budget3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446cf72",
  null
  
)

export default component.exports